import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from './lib/router';
import { initAnalytics } from './lib/analytics';
import { App } from './App';
import './styles.css';

/*
 * Data is treated as slow-moving: the graph is rebuilt by a worker on a
 * schedule, not edited by the person reading it, so refetching on window
 * focus would spend requests to show the same numbers. Facet counts in
 * particular are expensive enough that caching them matters.
 */
const client = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// Before the first render, so the first page view has a tag to reach.
// Does nothing unless VITE_GA_ID was set when the bundle was built.
initAnalytics();

const root = document.getElementById('root');
if (!root) throw new Error('#root missing from index.html');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      <RouterProvider>
        <App />
      </RouterProvider>
    </QueryClientProvider>
  </StrictMode>,
);
